import React from "react"
import { useAppCtx } from "lib/state"
import { appTools, cn } from "lib/utils"



export default function DetailScreensEditor(){
  
  return (
    <div className="w-full relative">
      <p>editor goes here</p>
    </div>
  )
}